import {Link} from 'react-router-dom'
import {useState, useRef, useCallback} from 'react'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import {Paper, Popper, Grow} from '@mui/material'

import Trigger from './Trigger'
import {Text, ButtonWrapper, MenuItemStyled, MenuListStyled} from './Dropdown.styles'

const Dropdown = ({
  trigger: CustomTrigger,
  customItem: CustomItem,
  title,
  options,
  onChange,
  placement,
  ...rest
}) => {
  const ref = useRef(null)
  const [open, setOpen] = useState(false)
  const onClick = () => setOpen(preState => !preState)

  const onAwayHandler = useCallback(event => {
    if (ref.current && ref.current.contains(event.target)) return
    setOpen(false)
  }, [])

  const Button = CustomTrigger || Trigger
  const Item = CustomItem || MenuItemStyled

  return (
    <>
      <ButtonWrapper ref={ref}>
        <Button active={open} onClick={onClick} title={title} {...rest}>
          {title}
        </Button>
      </ButtonWrapper>
      <Popper
        open={open}
        anchorEl={ref.current}
        role={undefined}
        transition
        placement={placement}
        disablePortal
        style={{zIndex: '1302'}}
      >
        {({TransitionProps, placement}) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={onAwayHandler}>
                <MenuListStyled>
                  {options &&
                    options.map(
                      ({
                        id,
                        iconBefore: IconBefore,
                        text,
                        iconAfter: IconAfter,
                        method,
                        link,
                        extranal,
                        ...rest
                      }) => (
                        <Item
                          id={id}
                          onClick={() => {
                            setOpen(false)
                            method && method()
                            onChange && onChange(id)
                          }}
                          key={id}
                          {...(link && !extranal && {component: Link, to: link})}
                          {...(link && extranal && {component: 'a', href: link, target: '_blank'})}
                          {...rest}
                        >
                          {IconBefore && <IconBefore />}
                          {text && (
                            <Text IconAfter={Boolean(IconAfter)} IconBefore={Boolean(IconBefore)}>
                              {text}
                            </Text>
                          )}
                          {IconAfter && <IconAfter />}
                        </Item>
                      ),
                    )}
                </MenuListStyled>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  )
}

export default Dropdown
